import {
  CommonResponseModel,
  DriverId,
  driverIdReq,
  DriverReq,
} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";
export class DriverServices extends CommonAxiosService {
  private URL = "/driver";

  async createDriver(req: DriverReq): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/createDriver", req);
  }

  async getActiveDriver(): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getActiveDriver");
  }

  async getAllDriver(): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getAllDriver");
  }

  async updateDriver(dto: any): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/updateDriver", dto);
  }

  async activateOrDeactivateDriver(dto: DriverId): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/activateOrDeactivateDriver", dto);
  }

  async fileUpload(file: any): Promise<CommonResponseModel> {
    return await this.axiosPostCall(this.URL + "/fileUpload", file);
  }

  async getDriverDetailsById(dto: DriverId): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getDriverDetailsById", dto);
  }


  async getDriversByType(req?:driverIdReq): Promise<CommonResponseModel> {
    // console.log(req);
    return this.axiosPostCall(this.URL + "/getDriversByType", req);
  }

  async getAvailableDrivers(): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getAvailableDrivers");
  } 

  async getAssignedDriversData(req?:any): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getAssignedDriversData", req);
  }

}
